import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { ImageStatIndicator2 } from "$/game/prefabs/ui/ImageStatIndicator2.ts";

export class EnergyIndicator extends ImageStatIndicator2 {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(
      myScene,
      x,
      y,
      myScene.atlas,
      myScene.keys.assets.sprites.ui.indicatorEnergy,
      1,
    );

    this.setValue(this.myScene.storage.pet().energy);

    this.myScene.registry.events.on("changedata-pet", () => {
      if (this.active) {
        this.setValue(this.myScene.storage.pet().energy);
      }
    });

    // Make the indicator interactive and add click handler
    this.setInteractive({
      hitArea: new Phaser.Geom.Rectangle(-50, -50, 100, 100),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    });
    this.on("pointerdown", () => {
      const pet = this.myScene.storage.pet();
      if (pet) {
        this.myScene.overlay.show("StatRestoreOverlay", true, {
          pet,
          stat: "energy",
        });
      }
    });
  }
}
